import axios from 'axios';

async function createAgendaByEmployee(employeeId, data) {
  const response = await axios.post(`/employees/${employeeId}/agenda/week`, data);

  return response.data;
}

async function createAgendaConfigByEmployee(employeeId, data) {
  const response = await axios.post(`/employees/${employeeId}/agenda/config`, data);

  return response.data;
}

async function createBookingForEmployee(employeeId, data) {
  const response = await axios.post(`/employees/${employeeId}/agenda/place_booking`, data);

  return response.data;
}

async function deleteBookingForEmployee(bookingId, employeeId) {
  const response = await axios.delete(`/employees/${employeeId}/agenda/place_booking/${bookingId}`);

  return response.data;
}

async function getAgendaByDates(employeeId, startDate, endDate) {
  const response = await axios.get(`/employees/${employeeId}/agenda?start_date=${startDate}&end_date=${endDate}`);

  return response.data;
}

async function getAgendaByEmployee(employeeId) {
  const response = await axios.get(`/employees/${employeeId}/agenda/by_employee`);

  return response.data;
}

async function getAgendaConfigByEmployee(employeeId) {
  const response = await axios.get(`/employees/${employeeId}/agenda/config`);

  return response.data;
}

async function getWeekAgendaByEmployee(employeeId) {
  const response = await axios.get(`/employees/${employeeId}/agenda/week`);

  return response.data;
}

async function updateBookingForEmployee(bookingId, employeeId, data) {
  const response = await axios.put(`/employees/${employeeId}/agenda/place_booking/${bookingId}`, data);

  return response.data;
}

async function updateConflictingEventsHours(data) {
  const response = await axios.put('/employees/agenda/week/conflicts', data);

  return response.data;
}

async function removeWeekAgenda(appointmentId) {
  const response = await axios.delete(`/employees/agenda/week/${appointmentId}`);

  return response.data;
}

async function transferAgenda(data) {
  const response = await axios.post('/employees/agenda/week/transfer', data);

  return response.data;
}

async function updateWeekAgenda(appointmentId, data) {
  const response = await axios.put(`/employees/agenda/week/${appointmentId}`, data);

  return response.data;
}

const agendaService = {
  createAgendaByEmployee,
  createAgendaConfigByEmployee,
  createBookingForEmployee,
  deleteBookingForEmployee,
  getAgendaByDates,
  getAgendaConfigByEmployee,
  getAgendaByEmployee,
  getWeekAgendaByEmployee,
  updateBookingForEmployee,
  updateConflictingEventsHours,
  removeWeekAgenda,
  transferAgenda,
  updateWeekAgenda
}

export default agendaService;
